import axios from "axios";

const useLocalProxy =
  import.meta.env.DEV && import.meta.env.VITE_USE_LOCAL_PROXY === "true";

// With the local proxy, API and download traffic stay same-origin: the Vite
// dev server proxies /v2 to the local backend and /output to the remote stage.
export const API_BASE_URL = useLocalProxy
  ? "/v2"
  : (import.meta.env.VITE_API_URL as string);
export const DOWNLOAD_BASE_URL = import.meta.env.VITE_DOWNLOAD_MOVEMENTS_URL;
export const CLOUDFRONT_URL = (
  import.meta.env.VITE_CLOUDFRONT_URL ?? ""
).replace(/\/$/, "");

export const configureAxiosBaseUrl = () => {
  axios.defaults.baseURL = API_BASE_URL;
};

export const normalizeDownloadUrl = (url: string): string => {
  if (!useLocalProxy) {
    return url;
  }

  if (url.startsWith("/output/")) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);
    const isRadarOutputUrl =
      parsedUrl.hostname.includes("somosradar.com") &&
      parsedUrl.pathname.startsWith("/output/");

    if (isRadarOutputUrl) {
      return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    }
  } catch {
    return url;
  }

  return url;
};
